import { CategoryDetailsPageContent } from "@app/grades/pages";
import { getCategoryService } from "@core/grades/services";
import { type GradeCategoryWithLessons } from "@core/grades/types";
import { getRootSettings, pageHead } from "@framework/config/drivers/meta";
import { publicRoutes } from "@framework/middleware";
import { plainTrans } from "@mongez/localization";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export const loader = publicRoutes(async ({ params, http, success }) => {
  const { id } = params;

  const { category } = await getCategoryService(http, id!);

  return success({ category });
});

export default function CategoryDetails() {
  const { category } = useLoaderData<{ category: GradeCategoryWithLessons }>();

  return <CategoryDetailsPageContent category={category} />;
}

export const meta: MetaFunction<typeof loader> = ({ data, matches }) => {
  const settings = getRootSettings(matches);
  // `data` is null when the loader threw, or lacks `category` when the
  // request failed and was converted to an error payload.
  const category = (data as any)?.category;
  const categoryName = category?.name || "";

  return pageHead({
    title: `${categoryName} - ${settings.general?.appName || ""}`,
    description: plainTrans("grades.categoryDescription", {
      category: categoryName,
    }),
    image: settings.general?.logo?.url || "",
    settings,
  });
};
